exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-0f27947e] {\n  padding: 0.052083rem 0;\n  border-bottom: 0.005208rem solid #cec9c9;\n}\n.el-form-item--medium[data-v-0f27947e] {\n  margin-bottom: 0 !important;\n}\n.diaWarp[data-v-0f27947e] {\n  font-size: 0.083333rem;\n  min-height: 20vh;\n}\n.diaWarp table td[data-v-0f27947e] {\n  height: 0.182292rem;\n  text-align: center;\n}\n.applyListWarp[data-v-0f27947e] {\n  display: flex;\n  padding: 0.052083rem 0;\n}\n.applyListWarp .labelName[data-v-0f27947e] {\n  font-size: 0.083333rem;\n  min-width: 0.520833rem;\n  font-weight: bold;\n  text-align: center;\n}", ""]);

// exports
